import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthContext } from '@/contexts/AuthContext'
import { AuthState } from '@/types/auth'

/**
 * 根路径重定向组件
 *
 * 根据认证状态自动重定向到相应页面：
 * - 未认证 → /login
 * - 需要 onboarding → /onboarding/organization
 * - 已认证 → /dashboard
 */
export function RootRedirect() {
  const { t } = useTranslation('chrome')
  const { state } = useAuthContext()

  // 等待认证状态确定
  if (
    state === AuthState.INITIALIZING ||
    state === AuthState.NEED_USER_SYNC
  ) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-muted">
        <div className="bg-card border border-border rounded-lg p-6 shadow-lg">
          <div className="flex items-center space-x-3">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">{t('auth.rootLoadingTitle')}</h3>
              <p className="text-sm text-muted-foreground mt-1">{t('auth.rootLoadingSubtitle')}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 错误状态
  if (state === AuthState.AUTH_ERROR) {
    return <Navigate to="/login" replace />
  }

  // 未认证
  if (state === AuthState.UNAUTHENTICATED) {
    return <Navigate to="/login" replace />
  }

  // 需要 onboarding
  if (state === AuthState.NEEDS_ONBOARDING) {
    return <Navigate to="/onboarding/organization" replace />
  }

  // 已认证
  if (state === AuthState.AUTHENTICATED) {
    return <Navigate to="/dashboard" replace />
  }

  // 未知状态（理论上不应该到这里）
  return <Navigate to="/login" replace />
}
